import { render } from "./PositionRequestMenu.vue?vue&type=template&id=bbf47c4a&scoped=true"
import script from "./PositionRequestMenu.vue?vue&type=script&lang=js"
export * from "./PositionRequestMenu.vue?vue&type=script&lang=js"

import "./PositionRequestMenu.vue?vue&type=style&index=0&id=bbf47c4a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf47c4a"]])

export default __exports__